export default __webpack_public_path__ + "static/media/drag-handle-dots-2.66e15ad8.svg";